var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.randomWidths),function(width,index){return _c('div',{key:index},[_c('vue-skeleton-loader',{staticClass:"mt-6 ml-6",attrs:{"width":width,"height":20}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }